import { render, staticRenderFns } from "./addStudent.vue?vue&type=template&id=1c9129cd&scoped=true&"
import script from "./addStudent.vue?vue&type=script&lang=js&"
export * from "./addStudent.vue?vue&type=script&lang=js&"
import style0 from "./addStudent.vue?vue&type=style&index=0&id=1c9129cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9129cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9129cd')) {
      api.createRecord('1c9129cd', component.options)
    } else {
      api.reload('1c9129cd', component.options)
    }
    module.hot.accept("./addStudent.vue?vue&type=template&id=1c9129cd&scoped=true&", function () {
      api.rerender('1c9129cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManage/userList/component/addStudent.vue"
export default component.exports